export const en = {
    full: 'Full',
    partial: 'Partial'
};
